import { StepState } from '../../../types'

interface GetStepStateProps {
  step: number
  currentStep: number
}

export const getStepState = ({ step, currentStep }: GetStepStateProps): StepState => {
  if (step < currentStep) {
    return StepState.Completed
  }
  if (step === currentStep) {
    return StepState.Current
  }
  return StepState.Upcoming
}
